import { authErrType } from '../constants/auth';
import { handleAuthData } from '../actions/auth/auth.action';
import { actionType } from '../constants/action-type';
import { store } from '@/configurations';
import { APP_SETTING_ACTION as appTypes, FLASH_TYPE } from '../constants/app';
import { checkFullLayoutRedirect } from '../helpers/global';

export const checkRequestError = (error, type) => {
    switch(type) {
        case authErrType.EXPIRED_SESSION:
            store.dispatch(handleAuthData({}, actionType.RESET));
            checkFullLayoutRedirect();
            // const toast = {
            //     type: FLASH_TYPE.ERROR,
            //     autoClose: true,
            //     errorCode: 'AUTH_EXPIRED',
            //     isOpen: true
            // }
            // store.dispatch({
            //     type: appTypes.SHOW_TOAST,
            //     toast: toast
            // })
            break;
        default: break;
    }
}